export default function scrollTo(
    element,
    { behavior = 'smooth', block = 'center' } = {},
) {
    element.scrollIntoView({ behavior, block });
}
